import { AllCommunityModule, AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { config as Infra } from 'zf-web-infra';

class GridConfig {

  private isInitialized = false;

  init(): void {
    if (this.isInitialized) {
      return;
    }

    if (Infra.AG_GRID_LICENSE_KEY !== '') {
      LicenseManager.setLicenseKey(Infra.AG_GRID_LICENSE_KEY);
    }

    ModuleRegistry.registerModules([
      AllEnterpriseModule,
      AllCommunityModule
    ]);

    this.isInitialized = true;
  }

}

export const license = new GridConfig();
